import React, { useEffect, useState } from "react";
import classNames from 'classnames';

import ElementModal from "./ElementModal";
import Checkbox from "../Checkbox";
import Row from "../Layout/Row";

import { projects, crops } from "../../constants";
import { findProjectTypeByName } from "constants/Projects";
import style from './_modal.module.scss';


export default function ProjectModal({isOpen, onClose, onSubmit, defaultValue}) {
	let className = classNames(style.modal);

	let [project, setProject] = useState(defaultValue || {type:""});
	let [error, setError] = useState(null);
	useEffect(() => setProject(defaultValue || {}), [defaultValue])

	function submit() {
		if(!project.name || project.name === "") {
			setError("Specifica il nome del progetto");
			return;
		}
		if(!project.projectTypeId) {
			setError("Specifica il tipo del progetto");
			return;
		}
		// imposta in ogni caso vuota la lista dei dss per i progetti diversi da agrismart/agrismart2
		if (project.projectTypeId !== findProjectTypeByName(projects.names.AGRISMART).id && project.projectTypeId !== findProjectTypeByName(projects.names.AGRISMART2).id) {
			project.cropNames = []
		}
		onSubmit(project);
	}

	function onChange(name, value) {
		let newProject = Object.assign({}, project,{[name]: value});
		setProject(newProject);
		setError(null);
	}

	function isDssEnabled(cropName) {
		return project.cropNames ? project.cropNames.includes(cropName) : false
	}

	function changeDssEnabled(cropName) {
		let cropNames = project.cropNames || []
		if (cropNames.includes(cropName)) {
			cropNames = cropNames.filter(n => n !== cropName)
		} else {
			cropNames.push(cropName)
		}
		onChange('cropNames', cropNames)
	}

	return (
		<ElementModal isOpen={isOpen} onClose={onClose} className={className} error={error} submit={submit}>
			<Row className={style.fields}>
				<input type={"text"} placeholder={"Nome progetto"} onChange={e => onChange("name",e.target.value)} value={project.name || ""}/>
			</Row>
			<Row className={style.fields}>
				<input type={"text"} placeholder={"Nome Azienda"} onChange={e => onChange("companyName",e.target.value)} value={project.companyName || ""}/>
			</Row>
			<Row className={style.fields}>
				{'Nascosto'}
				<Checkbox
					checked={project.hidden}
					onCheck={e => onChange("hidden", e.target.checked)}
				/>
			</Row>
			<div className={style.section}>
				<div className={style.title}>TIPOLOGIA</div>
				{
					projects.types.map(({name, id}) =>
						<Row key={id}>
							<Checkbox
								checked={project.projectTypeId === id}
								onCheck={() => onChange("projectTypeId", id)}
							/>
							{name}
						</Row>
					)
				}
			</div>
			{(project.projectTypeId === findProjectTypeByName(projects.names.AGRISMART).id || project.projectTypeId === findProjectTypeByName(projects.names.AGRISMART2).id) && 
				<div className={style.section}>
					<div className={style.title}>DSS</div>
					{
						crops.crops.map(({ name, id }) =>
							<Row key={id}>
								<Checkbox
									checked={isDssEnabled(name)}
									onCheck={() => changeDssEnabled(name)}
								/>
								{name}
							</Row>
						)
					}
				</div>
			}
		</ElementModal>
	)

}
